// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"48273fa7","668":"125f20e5","838":"718e91c9"}[chunkId] + ".js";
};